<script>
import { Field, Row, Col } from 'vant'
import Game from '@/tbs/model/to/Game'

const game = new Game

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'game-score-input',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-field': Field,
        'van-row': Row,
        'van-col': Col,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        homeTeamName: String,
        homeTeamScore: String,
        homeTeamPenaltyScore: String,
        awayTeamName: String,
        awayTeamScore: String,
        awayTeamPenaltyScore: String,
        description: String,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            hTeamScore: null,
            hTeamPenaltyScore: null,
            aTeamScore: null,
            aTeamPenaltyScore: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        versusField() {
            return game.localeProp('game-versus')
        },
        scoreField() {
            return game.localeProp('score')
        },
        regularField() {
            return game.localeProp('regular-game')
        },
        penaltyField() {
            return game.localeProp('penalty-score')
        },
        isPenaltyShow() {
            console.log('isPenaltyShow', this.hTeamScore, this.aTeamScore)
            if (this.hTeamScore != null && this.hTeamScore != '' 
                && this.aTeamScore != null && this.aTeamScore != ''
                && this.hTeamScore == this.aTeamScore) {
                return true
            }
            else if (this.homeTeamScore != null && this.homeTeamScore != '' 
                && this.awayTeamScore != null && this.awayTeamScore != ''
                && this.homeTeamScore == this.awayTeamScore) {
                return true
            }
            else {
                return false
            }
        },
        homeTeamScoreField: {
            get() {
                return (this.hTeamScore != null ? this.hTeamScore : this.homeTeamScore)
            },
            set(value) {
                this.hTeamScore = value
            }
        },
        awayTeamScoreField: {
            get() {
                return (this.aTeamScore != null ? this.aTeamScore : this.awayTeamScore)
            },
            set(value) {
                this.aTeamScore = value
            }
        },
        homeTeamPenaltyScoreField: {
            get() {
                return (this.hTeamPenaltyScore != null ? this.hTeamPenaltyScore : this.homeTeamPenaltyScore)
            },
            set(value) {
                this.hTeamPenaltyScore = value
            }
        },
        awayTeamPenaltyScoreField: {
            get() {
                return (this.aTeamPenaltyScore != null ? this.aTeamPenaltyScore : this.awayTeamPenaltyScore)
            },
            set(value) {
                this.aTeamPenaltyScore = value
            }
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onFieldInput() {
            this.hTeamScore = (this.hTeamScore == null ? this.homeTeamScore : this.hTeamScore)
            this.aTeamScore = (this.aTeamScore == null ? this.awayTeamScore : this.aTeamScore)
            this.hTeamPenaltyScore = (this.hTeamPenaltyScore == null ? this.homeTeamPenaltyScore : this.hTeamPenaltyScore)
            this.aTeamPenaltyScore = (this.aTeamPenaltyScore == null ? this.awayTeamPenaltyScore : this.aTeamPenaltyScore)
            if (this.hTeamScore && this.aTeamScore) {
                this.$emit('change-data', {
                    homeTeamScore: this.hTeamScore,
                    awayTeamScore: this.aTeamScore,
                    homeTeamPenaltyScore: this.hTeamPenaltyScore,
                    awayTeamPenaltyScore: this.aTeamPenaltyScore,
                })
            }
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="game-score-input bg-white u-outer-padding">
        <van-row type="flex" justify="center">
            <van-col span="9" class="justify-right vertical-center">
                <span class="main-text main-secondary-color h-inner-padding">{{ homeTeamName }}</span>
            </van-col>
            <van-col span="6" class="justify-center vertical-center">
                <span class="text-title main-secondary-color">{{ versusField }}</span>
            </van-col>
            <van-col span="9" class="justify-left vertical-center">
                <span class="main-text main-secondary-color h-inner-padding">{{ awayTeamName }}</span>
            </van-col>
        </van-row>
        <van-row type="flex" justify="center" class="b-outer-margin">
            <van-col span="9" class="score-field">
                <van-field 
                    v-model="homeTeamScoreField" 
                    type="digit" 
                    clearable
                    input-align="right"
                    @input="onFieldInput"
                />
            </van-col>
            <van-col span="6" class="text-center t-narrow-margin">
                <div>
                    <span class="text-title main-secondary-color ">{{ scoreField }}</span>
                </div>
                <div>
                    <span class="minor-text minor-color">{{ regularField }}</span>
                </div>    
            </van-col>
            <van-col span="9" class="score-field">
                <van-field 
                    v-model="awayTeamScoreField" 
                    type="digit" 
                    clearable
                    @input="onFieldInput"
                />
            </van-col>
        </van-row>
        <van-row v-if="isPenaltyShow" type="flex" justify="center" class="b-outer-margin">
            <van-col span="9" class="score-field">
                <van-field 
                    v-model="homeTeamPenaltyScoreField" 
                    type="digit" 
                    clearable
                    input-align="right"
                    @input="onFieldInput"
                />
            </van-col>
            <van-col span="6" class="justify-center vertical-center">
                <span class="text-title main-secondary-color ">{{ penaltyField }}</span>
            </van-col>
            <van-col span="9" class="score-field">
                <van-field 
                    v-model="awayTeamPenaltyScoreField" 
                    type="digit" 
                    clearable
                    @input="onFieldInput"
                />
            </van-col>
        </van-row>
        <van-row v-if="description" type="flex" justify="end" class="b-outer-margin">
            <van-col>
                <span class="minor-text minor-color">{{ description }}</span>
            </van-col>
        </van-row>
    </div>
</template>

<style scoped>
.score-field .van-field {
    background-color: #F2F3F5;
}
</style>